import { CheckCircle, Cancel } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";

const ComplianceIcon = ({ value }: { value: boolean }) => {
  if (value) {
    return (
      <Tooltip title="Verified">
        <CheckCircle color="success" fontSize="small" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Missing">
      <Cancel color="error" fontSize="small" />
    </Tooltip>
  );
};

export const trailerComplianceMatrixColumns: GridColDef[] = [
  {
    field: "unitNumber",
    headerName: "Unit Number",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => (
      <Link
        to={`/fleet/assets/trailer/${params.row.trailerId ?? params.row.id}`}
        onClick={(event) => event.stopPropagation()}
      >
        {params.value}
      </Link>
    ),
  },

  {
    field: "transactionType",
    headerName: "Transaction Type",
    minWidth: 170,
    flex: 1,
  },

  {
    field: "authorityCompanyName",
    headerName: "Authority Company",
    minWidth: 220,
    flex: 1.4,
  },
  {
    field: "billToCompanyName",
    headerName: "Bill To Company",
    minWidth: 220,
    flex: 1.4,
  },
  {
    field: "hasLeaseAgreement",
    headerName: "Lease Agreement",
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    sortable: false,
    renderCell: (params) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ComplianceIcon value={Boolean(params.value)} />
      </Box>
    ),
  },
  {
    field: "hasCertificateOfInsurance",
    headerName: "Certificate of Insurance",
    minWidth: 220,
    align: "center",
    headerAlign: "center",
    sortable: false,
    renderCell: (params) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ComplianceIcon value={Boolean(params.value)} />
      </Box>
    ),
  },
  {
    field: "hasRegistration",
    headerName: "Registration",
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    sortable: false,
    renderCell: (params) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ComplianceIcon value={Boolean(params.value)} />
      </Box>
    ),
  },
  {
    field: "hasAnnualInspection",
    headerName: "Annual Inspection",
    minWidth: 170,
    align: "center",
    headerAlign: "center",
    sortable: false,
    renderCell: (params) => (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ComplianceIcon value={Boolean(params.value)} />
      </Box>
    ),
  },
];
